export default "__VITE_ASSET__B_VzOG6I__"